import { render, staticRenderFns } from "./InventoryDeliveryChange.vue?vue&type=template&id=32137571&"
import script from "./InventoryDeliveryChange.vue?vue&type=script&lang=ts&"
export * from "./InventoryDeliveryChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports